/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertificateReceiveBatch extends Ce {
    constructor() {
        super();
        this.baseUrl += '/certificateReceiveBatch';
    }

    data({
        batchSn,
        batchName,
        certificateReceiveBatchType,
        expressShipMethod,
        certificateReceiveBatchStatus,
        expressName,
        trackingNumber,
        costBearingMode,
        statusChangeTime,
        insertTime,
        operatorName,
        viewNotComplete,
        enterpriseId,
        enterpriseName,
        certificateReceiveStatus,
        shipMethod,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        let statusChangeTimeBegin = null;
        let statusChangeTimeEnd = null;
        if (statusChangeTime != null && statusChangeTime.length === 2) {
            [statusChangeTimeBegin, statusChangeTimeEnd] = statusChangeTime;
        }
        return super.get('/data', {
            batchSn,
            batchName,
            certificateReceiveBatchType,
            expressShipMethod,
            certificateReceiveBatchStatus,
            expressName,
            trackingNumber,
            costBearingMode,
            insertTimeBegin,
            insertTimeEnd,
            statusChangeTimeBegin,
            statusChangeTimeEnd,
            operatorName,
            viewNotComplete,
            enterpriseId,
            enterpriseName,
            certificateReceiveStatus,
            shipMethod,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({
        id,
        batchSn,
        batchName,
        costBearingMode,
        expressId,
        expressName,
        expressCode,
        certificateReceiveBatchType,
        expressShipMethod,
        enterpriseId,
    } = {}) {
        return super.post('/save', {
            id,
            batchSn,
            batchName,
            costBearingMode,
            expressId,
            expressName,
            expressCode,
            certificateReceiveBatchType,
            expressShipMethod,
            enterpriseId,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    submitBatch({ id }) {
        return super.post('/submitBatch', { id });
    }

    backWaitConfirm({ id }) {
        return super.post('/backWaitConfirm', { id });
    }

    shipping({
        id,
        costBearingMode,
        expressId,
        expressName,
        expressCode,
        trackingNumber,
        isUseApi,
        deliveryConsignee,
        deliveryPhone,
        deliveryRegionId,
        deliveryAddress,
    }) {
        return super.post('/shipping', {
            id,
            costBearingMode,
            expressId,
            expressName,
            expressCode,
            trackingNumber,
            isUseApi,
            deliveryConsignee,
            deliveryPhone,
            deliveryRegionId,
            deliveryAddress,
        });
    }

    getLodopPrintInfo(param) {
        return super.get('/getLodopPrintInfo', { ...param });
    }

    updatePrintStatus(param) {
        return super.post('/updatePrintStatus', { ...param });
    }

    sendConfirmMessage({ ids }) {
        return super.post('/sendConfirmMessage', { ids });
    }

    createGroupBatch() {
        return super.post('/createGroupBatch');
    }

    confirmShipMethod({ id, deliveryConsignee, deliveryPhone, deliveryRegionId, deliveryAddress, shipMethod }) {
        return super.post('/confirmShipMethod', {
            id,
            deliveryConsignee,
            deliveryPhone,
            deliveryRegionId,
            deliveryAddress,
            shipMethod,
        });
    }

    setDelivery({ certificateReceiveBatchId, certificateReceiveDetailId }) {
        return super.post('/setDelivery', {
            certificateReceiveBatchId,
            certificateReceiveDetailId,
        });
    }
}

export default new CertificateReceiveBatch();
export { CertificateReceiveBatch };
